module.exports = __webpack_public_path__ + "static/coph3-a07b979598e867464acd6fb9971085ed.jpg";